import { render } from "./SignInWidget.vue?vue&type=template&id=343bd552&scoped=true"
import script from "./SignInWidget.vue?vue&type=script&lang=js"
export * from "./SignInWidget.vue?vue&type=script&lang=js"

import "./SignInWidget.vue?vue&type=style&index=0&id=343bd552&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\zacha\\repos\\jhhe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343bd552"]])

export default __exports__